export default __webpack_public_path__ + "static/media/Avatar-3.e783bbc4.png";